import { useSelector } from 'react-redux';
import useDispatcher from '../../hooks/useDispatcher';
import { ReduxState } from '../../interfaces';
import { AT } from '../../actions/actionTypes';

export const useDevices = () => {
  const state = useSelector((s: ReduxState) => s.devicesState);
  const { doEmptyAction } = useDispatcher();

  const refreshData = () => {
    doEmptyAction(AT.DEVICES.RESET);
  };

  return {
    selectedKeys: state.selection.selectedKeys,
    refreshData,
  };
};

export default useDevices;
